// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, FormControl, MenuItem, Select } from '@mui/material'

import React from 'react'
import { Mutation } from 'react-apollo'
import {
  createActivityDescriptionMutation,
  fetchStationActivityDescriptions,
  updateActivityDescriptionMutation,
} from '../../activityDescription/activityDescriptionQueries'
import { ActivityDescription } from '../../activityDescription/activityDescriptionTypes'
import { i18n } from '../../index'
import { positionOptions } from '../../staffingPlan/StaffingPlan'
import css from './activityDescriptionPage.css'

type Props = {
  data: Array<ActivityDescription>
  stationId?: string
}

type State = {
  id: string
  name: string
  description: string
  isEditing: boolean
}

class ActivityDescriptionPage extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    positionOptions.pop()

    const defaultActivityName = this.getDefaultActivity().value
    const filteredDescription = this.getActivityDescriptionByName(defaultActivityName)
    this.state = {
      id: filteredDescription.length ? filteredDescription[0].id : '',
      name: defaultActivityName,
      description: filteredDescription.length ? filteredDescription[0].description : this.getDefaultDescription(),
      isEditing: false,
    }
  }

  getDefaultActivity = () => positionOptions[0]

  getDefaultDescription = () => `${i18n.t('common.morningShift')}:

${i18n.t('common.eveningShift')}:

${i18n.t('common.nightShift')}:`

  getActivityDescriptionByName = (name: string) => {
    const { data: activityDescriptions, stationId } = this.props
    return activityDescriptions.filter((d) => d.name === name && d.station.id === stationId)
  }

  changeOption = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const name = e.target.value
    const filteredDescription = this.getActivityDescriptionByName(name)
    const description = filteredDescription.length ? filteredDescription[0].description : this.getDefaultDescription()
    const id = filteredDescription.length ? filteredDescription[0].id : ''
    this.setState({
      id,
      name,
      description,
      isEditing: false,
    })
  }

  toggleEdit = () => {
    this.setState({
      isEditing: !this.state.isEditing,
    })
  }

  onSubmit = async (onMutate: (...props: any) => any) => {
    const { id, name, description } = this.state
    const { stationId } = this.props

    const params = {
      variables: id
        ? {
            activityDescriptionId: id,
            description,
          }
        : {
            name,
            description,
            stationId,
          },
    }

    if (!id) {
      params.update = (cache, { data: { createActivityDescription } }) => {
        const variables = { stationId }
        const { stationActivityDescriptions } = cache.readQuery({
          query: fetchStationActivityDescriptions,
          variables,
        })
        cache.writeQuery({
          query: fetchStationActivityDescriptions,
          variables,
          data: {
            stationActivityDescriptions: stationActivityDescriptions.concat([createActivityDescription]),
          },
        })
        this.setState({
          id: createActivityDescription.id,
        })
      }
    }

    await onMutate(params)
    this.toggleEdit()
  }

  changeDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({
      description: e.target.value,
    })
  }

  render() {
    const { id, name, description, isEditing } = this.state

    return (
      <div className={css.wrapper}>
        <FormControl className={css.select}>
          <Select
            fullWidth
            value={name}
            onChange={this.changeOption}
            inputProps={{
              id: 'activity',
            }}
          >
            {positionOptions.map((option, i) => (
              <MenuItem key={i} value={option.value}>
                {i18n.t(`staffingPlan.positions.${option.label}`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <textarea
          className={css.description}
          rows={16}
          value={description}
          disabled={!isEditing}
          onChange={this.changeDescription}
        />
        <div className={css.btns}>
          <Button onClick={this.toggleEdit} className={css.btn} variant='contained' color='primary'>
            {isEditing ? i18n.t('buttons.cancel') : i18n.t('buttons.edit')}
          </Button>
          {isEditing && (
            <Mutation mutation={id ? updateActivityDescriptionMutation : createActivityDescriptionMutation}>
              {(onMutate) => (
                <Button onClick={() => this.onSubmit(onMutate)} className={css.btn} variant='contained' color='primary'>
                  {i18n.t('buttons.save')}
                </Button>
              )}
            </Mutation>
          )}
        </div>
      </div>
    )
  }
}

export default ActivityDescriptionPage
